import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Palette, RotateCcw, Star } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { API, DEFAULT_COLORS, LEVELS, setStarColors } from './stars';

const RANGES = { 1: '1,49 ve altı', 2: '1,50 – 2,49', 3: '2,50 – 3,49', 4: '3,50 – 4,49', 5: '4,50 ve üstü' };

const Row = ({ n, color, onChange }) => (
  <div className="flex items-center gap-4 rounded-lg border px-3 py-2" data-testid={`star-color-row-${n}`}>
    <span className="flex">{[1, 2, 3, 4, 5].map(i => <Star key={i} className={`h-5 w-5 ${i <= n ? 'fill-current' : 'text-slate-300'}`} style={i <= n ? { color } : undefined} />)}</span>
    <span className="w-20 text-sm font-semibold" style={{ color }}>{LEVELS[n]}</span>
    <span className="w-28 text-xs text-slate-500">{RANGES[n]}</span>
    <input type="color" value={color} onChange={e => onChange(e.target.value)} className="h-8 w-12 cursor-pointer rounded border" data-testid={`star-color-input-${n}`} />
    <span className="font-mono text-xs text-slate-500">{color}</span>
  </div>
);

export const StarColorsCard = () => {
  const [c, setC] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { axios.get(`${API}/five-star/colors`).then(r => setC(r.data.colors)).catch(() => {}); }, []);
  if (!c) return null;
  const save = async () => {
    setSaving(true);
    try { const { data } = await axios.put(`${API}/five-star/colors`, { colors: c }); setC(data.colors); setStarColors(data.colors); toast.success('Yıldız renkleri kaydedildi'); }
    catch (e) { toast.error(e.response?.data?.detail || 'Kaydedilemedi'); } finally { setSaving(false); }
  };
  return (
    <Card className="max-w-3xl border-slate-200" data-testid="star-colors-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><Palette className="h-5 w-5 text-slate-600" />Yıldız Renkleri</CardTitle>
        <CardDescription>Puan seviyelerinin rengi; denetim ekranı, Çalışma İzinleri, Firma Değerlendirme ve tüm Five Star PDF'lerinde (rapor, karne, sertifika) kullanılır. Puan yuvarlanarak seviyeye eşlenir.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        {[1, 2, 3, 4, 5].map(n => <Row key={n} n={n} color={c[n]} onChange={v => setC({ ...c, [n]: v })} />)}
        <div className="flex gap-2 pt-2">
          <Button onClick={save} disabled={saving} data-testid="star-colors-save">Renkleri Kaydet</Button>
          <Button variant="outline" onClick={() => setC(DEFAULT_COLORS)} data-testid="star-colors-reset"><RotateCcw className="mr-1 h-4 w-4" />Varsayılana Dön</Button>
        </div>
      </CardContent>
    </Card>
  );
};
